import { Component } from '@angular/core'
import { IonicPage, NavController, NavParams } from 'ionic-angular'

import { LoadingController } from 'ionic-angular'
import { ToastController } from 'ionic-angular'
import { MessageProvider } from '../../providers/message/message'
import { HousingUnit, Message } from '../../models/models'
import { ConfigProvider } from '../../providers/config/config'
@IonicPage()
@Component({
	selector: 'page-message-create-intercom',
	templateUrl: 'message-create-intercom.html',
})
export class MessageCreateIntercomPage {
	public housingUnit: HousingUnit
	body: string = '';
	private _popTimeout: number

	constructor(
		private messages: MessageProvider,
		private navCtrl: NavController,
		private navParams: NavParams,
		private toastCtrl: ToastController,
		private loadingCtrl: LoadingController
	) {
		this.housingUnit = navParams.get("housingUnit")
		if(!this.housingUnit) {
			console.error('[MessageCreateIntercomPage.construction()] Unità abitativa richiesta per inviare un messaggio')
			navCtrl.pop()
		}
		this.resetTimeout()
	}

	back() {
		let toast = this.toastCtrl.create({
			message: 'Messaggio annullato',
			position: 'middle',
			duration: 3000
		})
		toast.present()
		this.navCtrl.pop()
	}

	public onModelChanged() {
		this.resetTimeout()
	}

	/**
	Reset del timeout che chiude la pagina dopo 1 minuto di inattività
	*/
	private resetTimeout() {
		console.debug('[MessageCreateIntercomPage.resetTimeout()]')

		if(this._popTimeout) {
			clearTimeout(this._popTimeout)
		}

		let self = this
		this._popTimeout = setTimeout(() => {
			let toast = this.toastCtrl.create({
				message: 'Azione annullata per inattività',
				position: 'middle',
				duration: 3000
			})
			toast.present()
			self.navCtrl.pop()
		}, ConfigProvider.TIMEOUT_INTERACTION * 1000)
	}

	send() {
		let self = this

		if(!this.body) {
			let toast = self.toastCtrl.create({
				message: "E' necessario scrivere qualcosa",
				position: 'middle',
				duration: 3000,
				cssClass: 'danger'
			})
			toast.present()
			return
		}

		let loader = this.loadingCtrl.create({
			content: "Invio.."
		})
		loader.present().then(value => {
			self.messages.sendToHousingUnit(self.housingUnit, self.body, "Messaggio dal citofono").then((message: Message) => {
				loader.dismiss()
				let toast = self.toastCtrl.create({
					message: "Messaggio inviato",
					position: 'middle',
					duration: 3000,
					cssClass: 'light'
				})
				self.navCtrl.pop()
				toast.present()
			}).catch(error => {
				loader.dismiss()
				let toast = self.toastCtrl.create({
					message: "Impossibile inviare il messaggio",
					position: 'middle',
					duration: 3000,
					cssClass: 'danger'
				})
				toast.present()
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/pages/message-create-intercom/message-create-intercom.ts